package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("fasting_longterm_results")
data class FastingLongTermResultsScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("header") val header: String? = null,
    @SerialName("chart") val chart: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
) : ScreenConfig